import {
	ADMINADDRISKRULELIST_SUCCESS,
	ADMINADDRISKRULELIST_FAILED,
	RESET_ADMINADDRISKRULELIST,
	LOADING_ADMINADDRISKRULELIST,
	NETWORK_ERROR_ADMINADDRISKRULELIST
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINADDRISKRULELIST:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINADDRISKRULELIST_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINADDRISKRULELIST_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINADDRISKRULELIST:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINADDRISKRULELIST:
			return (state = initialState);
		default:
			return state;
	}
};
